import {
    loginApi,
    logoutApi,
    loadTokenFromLocalStorage,
    saveTokenInLocalStorage,
} from '../../services/AuthService';

export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION    = '[login action] failed login';
export const LOGOUT_ACTION          = '[Logout action] logout action';
export const LOADING_TOGGLE_ACTION  = '[Loading action] toggle loading';
export const NAVTOGGLE              = 'NAVTOGGLE';

export function loginAction(username, password, navigate) {
    return (dispatch) => {
        loginApi(username, password)
            .then((response) => {
                saveTokenInLocalStorage(response.data);
                dispatch(loginConfirmedAction(response.data));
                if (!response.data.must_change_password) {
                    sessionStorage.setItem('justLoggedIn', '1');
                }
                navigate(response.data.must_change_password ? '/change-password' : '/dashboard');
            })
            .catch((error) => {
                const data = error.response?.data;
                const msg =
                    data?.non_field_errors?.[0] ||
                    data?.detail ||
                    (data && typeof data === 'object'
                        ? Object.values(data).flat().find(v => typeof v === 'string')
                        : null) ||
                    'Login failed. Check your credentials.';
                dispatch(loginFailedAction(msg));
            });
    };
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetails = loadTokenFromLocalStorage();
    if (!tokenDetails) {
        dispatch(Logout(navigate));
        return;
    }

    // Only reject if the JWT is actually expired — do not start a timer here.
    // Session timeout is managed by the idle timer in App.js.
    const expireDate = new Date(tokenDetails.expireDate);
    if (new Date() > expireDate) {
        dispatch(Logout(navigate));
        return;
    }

    dispatch(loginConfirmedAction(tokenDetails));

    // If admin required a password change, redirect to the change-password screen
    if (tokenDetails.must_change_password) {
        navigate('/change-password');
    }
}

export function Logout(navigate) {
    const details = loadTokenFromLocalStorage();
    logoutApi(details?.access); // fire-and-forget audit entry
    localStorage.removeItem('userDetails');
    if (navigate) navigate('/login');
    return { type: LOGOUT_ACTION };
}

export function loginConfirmedAction(data) {
    return { type: LOGIN_CONFIRMED_ACTION, payload: data };
}

export function loginFailedAction(message) {
    return { type: LOGIN_FAILED_ACTION, payload: message };
}

export function loadingToggleAction(status) {
    return { type: LOADING_TOGGLE_ACTION, payload: status };
}

export const navtoggle = () => ({ type: 'NAVTOGGLE' });

// Self-registration is managed through the Django admin — not available via the app.
export function signupAction() {
    return (dispatch) => {
        dispatch(loginFailedAction('Self-registration is not available. Contact your administrator.'));
    };
}
